import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.scss'
import App from './App'
import './index.scss';
import { BrowserRouter } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('Root'));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
